var map = {
	"./coldev/coldev.module": [
		"./src/app/coldev/coldev.module.ts",
		"default~coldev-coldev-module~confirminvoice-confirminvoice-module~unsyncdata-unsyncdata-module",
		"default~coldev-coldev-module~unsyncdata-unsyncdata-module",
		"coldev-coldev-module"
	],
	"./colectionview/colectionview.module": [
		"./src/app/colectionview/colectionview.module.ts",
		"colectionview-colectionview-module"
	],
	"./collectionitems/collectionitems.module": [
		"./src/app/collectionitems/collectionitems.module.ts",
		"collectionitems-collectionitems-module"
	],
	"./confirminvoice/confirminvoice.module": [
		"./src/app/confirminvoice/confirminvoice.module.ts",
		"default~coldev-coldev-module~confirminvoice-confirminvoice-module~unsyncdata-unsyncdata-module",
		"confirminvoice-confirminvoice-module"
	],
	"./createcustomitem/createcustomitem.module": [
		"./src/app/createcustomitem/createcustomitem.module.ts",
		"createcustomitem-createcustomitem-module"
	],
	"./createlocalcustomer/createlocalcustomer.module": [
		"./src/app/createlocalcustomer/createlocalcustomer.module.ts",
		"createlocalcustomer-createlocalcustomer-module"
	],
	"./createlocalinvoice/createlocalinvoice.module": [
		"./src/app/createlocalinvoice/createlocalinvoice.module.ts",
		"createlocalinvoice-createlocalinvoice-module"
	],
	"./deliveryitemview/deliveryitemview.module": [
		"./src/app/deliveryitemview/deliveryitemview.module.ts",
		"deliveryitemview-deliveryitemview-module"
	],
	"./deliverymakepayment/deliverymakepayment.module": [
		"./src/app/deliverymakepayment/deliverymakepayment.module.ts",
		"common",
		"deliverymakepayment-deliverymakepayment-module"
	],
	"./deliveryview/deliveryview.module": [
		"./src/app/deliveryview/deliveryview.module.ts",
		"deliveryview-deliveryview-module"
	],
	"./driversummary/driversummary.module": [
		"./src/app/driversummary/driversummary.module.ts",
		"driversummary-driversummary-module"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		"login-login-module"
	],
	"./selectcategory/selectcategory.module": [
		"./src/app/selectcategory/selectcategory.module.ts",
		"selectcategory-selectcategory-module"
	],
	"./selectitemlist/selectitemlist.module": [
		"./src/app/selectitemlist/selectitemlist.module.ts",
		"selectitemlist-selectitemlist-module"
	],
	"./unsyncdata/unsyncdata.module": [
		"./src/app/unsyncdata/unsyncdata.module.ts",
		"default~coldev-coldev-module~confirminvoice-confirminvoice-module~unsyncdata-unsyncdata-module",
		"default~coldev-coldev-module~unsyncdata-unsyncdata-module",
		"common",
		"unsyncdata-unsyncdata-module"
	],
	"./viewmap/viewmap.module": [
		"./src/app/viewmap/viewmap.module.ts",
		"viewmap-viewmap-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;